import mixpanel from 'mixpanel-browser'
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN)

export function invitePageViewed() {
  mixpanel.track('View Invite Page')
}

export function signedIn(userId) {
  mixpanel.identify(userId)
  mixpanel.track('Log In')
}

export function signedOut() {
  // There are trade-offs using reset with super props but this allows different
  // users to use the same device and be tracked individually.
  // https://help.mixpanel.com/hc/en-us/articles/115004497803-Identity-Management-Best-Practices
  mixpanel.reset()
}

export function completedOnboardingStep(stepName) {
  mixpanel.track('Complete Onboarding Step', { 'Step Name': stepName })
}

export function inviteBegun(inviteType) {
  mixpanel.track('Begin Invite', { 'Invite Type': inviteType })
  mixpanel.people.increment('Invite Intents')
}

export function signedUp(user) {
  const { id, email, firstName, lastName, provider, community } = user
  mixpanel.identify(id)
  mixpanel.track('Sign Up')
  mixpanel.people.set({
    'Provider': provider,
    '$first_name': firstName,
    '$last_name': lastName,
    '$email': email,
    'Community Id': community
  })
}
